export default __webpack_public_path__ + "static/media/header_landing_foto.f3400417.jpg";